import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store/store";
import axios from "axios";
import { convertTextToPdf } from "../services/upload-to-backend";
import { getDocumentMetadata, getPageData } from "../services/document-service";
import { setFileStore, setFileType } from "../store/file-slice";

export const useContract = () => {
	const fileData = useSelector((state: RootState) => state.files);
	const apiUrl = process.env.API_URL;
	const dispatch = useDispatch();

	const uploadContract = async (pdfFile: File = null, forPlaybook = false, fileName = null, userId: string) => {
		let pdfBlob: File | Blob;

		if (pdfFile) {
			pdfBlob = pdfFile;
		} else {
			const textContent = await getPageData();
			pdfBlob = await convertTextToPdf(textContent);
		}

		const formData = new FormData();

		// this is called autoFileName because it finds the fileName for us in case
		// we dont have it because we are trying to upload the file opened in the add in
		// otherwise if user is uploading a file with our input button then logic needs to send a name in this
		// function
		const autoFileName = await getDocumentMetadata();

		// Building the payload to upload the API.
		formData.append("document", pdfBlob, fileName || autoFileName);
		formData.append("userId", userId);

		// Uploading the file along with payload to the backend.
		const response = await axios.post(apiUrl + "/api/v1/contracts/upload-contracts", formData, {
			headers: {
				Authorization: `Bearer ${localStorage.getItem("authToken")}`,
			},
		});
		if (response.data.success) {
			if (!forPlaybook) {
				dispatch(
					setFileStore({
						fileId: response.data.fileIds[0]["fileId"],
						fileType: { value: response.data.fileIds[0]["code"], label: response.data.fileIds[0]["name"] },
					})
				);
			}
			return response.data.fileIds;
		}
	};

	const changeContractType = async (label, value, userId) => {
		const contractData = {
			fileId: fileData.fileId,
			code: value,
			name: label,
		};
		const res = await fetch(`${apiUrl}/api/v1/contracts/change-contract-type`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${localStorage.getItem("authToken")}`,
			},
			body: JSON.stringify({ userId: userId, contractData: [contractData] }),
		});
		const response = await res.json();

		if (!response.success || !res.ok) {
			console.log("error here need to add handling here to show errors properly");
		} else {
			console.log("reached here", label, value);
			dispatch(setFileType({ label: label, value: value }));
		}
	};

	const checkFileCompatibility = (event: any) => {
		const file = event.target.files?.[0];
		if (!file) return;

		const allowedTypes = [
			"text/csv",
			"application/pdf",
			"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
		];

		if (!allowedTypes.includes(file.type)) {
			return {
				success: false,
				message: "The file format is not supported. Please upload a PDF, DOCX, or CSV file.",
				file: null,
			};
		}

		return { success: true, file };
	};

	return { uploadContract, changeContractType, checkFileCompatibility };
};

export const contractTypes = [
	{ label: "Master Service Agreement (MSA)", value: "master_service" },
	{ label: "Non-Disclosure Agreement (NDA)", value: "non_disclosure" },
	{ label: "Data Processing Agreement (DPA)", value: "data_processing" },
	{ label: "Statement of Work (SOW)", value: "statement_of_work" },
	{ label: "Others", value: "unknown" },
];
